/**
 * Roles típicos: 1 superadmin, 2 admin.
 * El reporte enrollments-by-oma solo lo permite el backend para admin/superadmin.
 */
export function getUserRoles() {
  try {
    const raw = localStorage.getItem('userData')
    if (!raw) return []
    const user = JSON.parse(raw)
    return Array.isArray(user?.roles) ? user.roles : []
  } catch {
    return []
  }
}

export function isWeightlossReportAdmin() {
  return getUserRoles().some(r => {
    const id = Number(r?.id ?? r?.role_id)
    const name = String(r?.name || '').toLowerCase()
    return id === 1 || id === 2 || name === 'superadmin' || name === 'admin'
  })
}
